var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgVirtualCategories = function SvgVirtualCategories(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.5 2.5)",
    stroke: "currentColor",
    strokeWidth: 1.2,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(90 2.5 2.5)",
    x: 0.6,
    y: 0.6,
    width: 3.8,
    height: 3.8,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(90 2.5 14.5)",
    x: 0.6,
    y: 12.6,
    width: 3.8,
    height: 3.8,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(90 2.5 8.5)",
    x: 0.6,
    y: 6.6,
    width: 3.8,
    height: 3.8,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(90 16.5 2.5)",
    x: 14.6,
    y: 0.6,
    width: 3.8,
    height: 3.8,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(90 16.5 14.5)",
    x: 14.6,
    y: 12.6,
    width: 3.8,
    height: 3.8,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(90 16.5 8.5)",
    x: 14.6,
    y: 6.6,
    width: 3.8,
    height: 3.8,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.42 2H7.5a.5.5 0 0 1 .5.5v12.25a.25.25 0 0 1-.25.25H4M14.58 2H11.5a.5.5 0 0 0-.5.5v12.25c0 .138.112.25.25.25H15m0-6H4.5"
  }))));
};

export default SvgVirtualCategories;